import { MarketResearchPublicOverviewData } from "../../types";
import {
    MarketResearchPublicOverviewResponse,
} from "../controllers/marketResearchPublic";
import {
    convertJobManagerContactResponse,
} from "./convertJobManagerContactResponse";

export const convertMarketResearchPublicOverviewResponse = (
    res: MarketResearchPublicOverviewResponse
) => {
    if (!res) return null;
    const result: MarketResearchPublicOverviewData = {
        canAccessJobMarketResearch: res.canAccessJobMarketResearch,
        canUpsellMarketResearch: res.canUpsellMarketResearch,
        isSharedFromAdmin: res.isSharedFromAdmin,
        jobManager: convertJobManagerContactResponse(
            res.jobManagerContactResponse
        ),
    };
    return result;
};
